import React, { useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';

import BaseButton from '../Buttons/BaseButton';
import BaseDialog from './BaseDialog';
import SweetAlert from '../Alerts/SweetAlert';

const BrebQrDialog = ({ open, qrImage, handleClose }) => {
  const classes = useStyles();

  const renderContent = useCallback(
    () => (
      <Box className={classes.container}>
        <SweetAlert
          id="id_qr_breb_alert"
          type="info"
          message={
            <>
              Ingresa a tu aplicación bancaria y escanea el código para
              continuar con el pago.
            </>
          }
        />
        <img src={qrImage} alt="Código QR de pago" className={classes.qr} />
      </Box>
    ),
    [classes.container, classes.qr, qrImage]
  );

  const renderActions = useCallback(
    () => <BaseButton onClick={handleClose}>Continuar</BaseButton>,
    [handleClose]
  );

  return (
    <BaseDialog
      open={open}
      handleClose={handleClose}
      title="Código QR de pago"
      content={renderContent}
      actions={renderActions}
      contentSize="small"
      contentStyle={classes.content}
    />
  );
};

const useStyles = makeStyles(theme => ({
  content: {
    padding: theme.spacing(0, 2)
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 0)
  },
  qr: {
    display: 'block',
    width: '100%',
    maxWidth: 280,
    height: 'auto',
    margin: '0 auto',
    padding: theme.spacing(1),
    backgroundColor: '#f5f5f5',
    borderRadius: theme.spacing(1)
  },
  instructions: {
    textAlign: 'center',
    color: theme.palette.text.primary,
    marginTop: theme.spacing(1)
  },
  note: {
    textAlign: 'center',
    color: theme.palette.text.secondary,
    fontStyle: 'italic',
    marginTop: theme.spacing(1)
  }
}));

export default BrebQrDialog;
